import React from "react";
import App from "./App";
import "./index.css";
import { ThemeProvider } from "./Context/ThemeContext";
import { createRoot } from "react-dom/client";
import "@fontsource/poppins";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { NotificationProvider } from "./Context/notificationContext";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </ThemeProvider>
  </React.StrictMode>
);
